import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=0ce191d8&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=js"
export * from "./MemberDetails.vue?vue&type=script&lang=js"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=0ce191d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce191d8",
  null
  
)

export default component.exports